import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Input, Row } from "antd";
import { API_BASE_URL, directToken, EDIT_CITY } from "../services/end_points";
import { _put } from "../services/service_api";
const EditCity = ({ data }) => {
  const [alert, setAlert] = useState(null);
  const [editing] = useState(true);
  const [formdata, setFormdata] = useState({ city: editing ? data.city : "" });
  const [success, setSuccess] = useState(false);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleReset = () => {
    setFormdata({ city: "" });
  };
  useEffect(() => {
    setFormdata({ city: data.city });
  }, [data]);
  const handleCity = async (e) => {
    e.preventDefault();
    const id = data.id;
    try {
      const response = await _put(
        `${API_BASE_URL}${EDIT_CITY}${id}`,
        formdata,
        directToken
      );
      setFormdata({ city: "" });
      window.location.reload();
      // updateUserList(response.data);
      setAlert({ type: "success", message: "City Updated" });
      setSuccess(true);
    } catch (err) {
      console.error("Error updating city:", err);
      setAlert({ type: "error", message: "Failed to update city" });
      setSuccess(false);
    }
  };

  return (
    <>
      <Row>
        <Form onFinish={handleCity} layout="vertical">
          <div>
            <div>
              {alert && (
                <div>
                  <Alert
                    type="success"
                    style={{
                      backgroundColor: "#dbffb8cf",
                      color: "black",
                      width: "100%",
                      marginTop: "0.5rem",
                      marginBottom: "2rem",
                    }}
                    message={"City Updated!"}
                  />
                </div>
              )}
            </div>

            <Col
              md={20}
              xl={24}
              lg={24}
              sm={24}
              style={{
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Form.Item label="Edit City" required>
                <Input
                  id="city"
                  name="city"
                  value={formdata.city}
                  onChange={handleFormChange}
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "1rem",
                  width: "20vw",
                }}
              >
                <Button
                  type="button"
                  onClick={handleReset}
                  style={{
                    color: "black",
                    border: "solid #1236fa",
                    marginRight: "auto",
                    width: "85px",
                    height: "32px",
                    borderRadius: "3vw",
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  onClick={handleCity}
                  style={{
                    color: "white",
                    background: "#1236fa",
                    width: "85px",
                    height: "32px",
                    borderRadius: "3vw",
                  }}
                >
                  Submit
                </Button>
              </div>
            </Col>
          </div>
        </Form>
      </Row>
    </>
  );
};

export default EditCity;
